/** Шаг идёт: у шага создания — «создаётся…», у прочих — «идёт…». */
export const STEP_CREATING_TEXT = 'создаётся…';
export const STEP_RUNNING_TEXT = 'идёт…';
/** Исход шага неизвестен: Meta могла выполнить запрос — проверяется. */
export const STEP_AMBIGUOUS_CREATE_TEXT = 'неизвестно — Meta могла создать, проверяется';
export const STEP_AMBIGUOUS_TEXT = 'неизвестно — Meta могла выполнить, проверяется';
/** Статус, которого экран не знает (новый auto-ads) — нейтрально, без кода. */
export const STEP_UNKNOWN_TEXT = 'статус неизвестен';
/** Шаг создания объекта Meta (а не включение / откат / сверка). */
export const isCreateStepKind = (kind) => kind != null && !kind.startsWith('activate') && kind !== 'rollback' && kind !== 'verify';
/** Подпись и тон каждого статуса контракта; `kind` уточняет «создаётся» / «идёт». */
export function stepStatusLabel(status, kind) {
    const create = isCreateStepKind(kind);
    switch (status) {
        case 'pending':
            return { label: 'ждёт', tone: 'neutral' };
        case 'in_progress':
            return { label: create ? STEP_CREATING_TEXT : STEP_RUNNING_TEXT, tone: 'info' };
        case 'ambiguous':
            return {
                label: create ? STEP_AMBIGUOUS_CREATE_TEXT : STEP_AMBIGUOUS_TEXT,
                tone: 'warning',
            };
        case 'done':
            return { label: 'готово', tone: 'success' };
        case 'failed':
            return { label: 'ошибка', tone: 'danger' };
        case 'skipped':
            return { label: 'пропущено', tone: 'neutral' };
        case 'rolled_back':
            return { label: 'удалено', tone: 'neutral' };
    }
}
//# sourceMappingURL=step-status.js.map